<div class="w9-agent-composer">
  <div class="w9-agent-composer__box" [class.w9-agent-composer__box--expanded]="focused() || !!value.trim()">
    <div class="w9-agent-composer__top-row">
      <div class="w9-agent-composer__input-area">
        <input
          type="text"
          class="w9-agent-composer__input"
          [value]="value"
          (input)="onInput($event)"
          (focus)="onFocus()"
          (blur)="onBlur()"
          (keydown.enter)="onSubmit()"
          aria-label="Message Sonder"
        />
        @if (showTry) {
          <div class="w9-agent-composer__try">
            <span class="w9-agent-composer__try-tag">TRY</span>
            <span #tryTextEl class="w9-agent-composer__try-text">{{ TRY_SUGGESTIONS[0] }}</span>
          </div>
        }
      </div>
      <button
        type="button"
        class="w9-agent-composer__send"
        [disabled]="!value.trim()"
        (click)="onSubmit()"
        aria-label="Send message"
      >
        <iris-icon name="send_alt" [size]="iconSizes.SM" [color]="iconColors.WHITE"></iris-icon>
      </button>
    </div>
    <div class="w9-agent-composer__toolbar"></div>
  </div>
</div>
